<template>
  <section class="tc-check" aria-labelledby="tu-construye-checklist-title">
    <h2 id="tu-construye-checklist-title" class="tc-check__title">Lo que necesitarás tener a la mano</h2>

    <ul class="tc-check__grid">
      <li v-for="document in documents" :key="document" class="tc-check__item">
        <img :src="checkIcon" alt="" aria-hidden="true">
        <span class="wd-body">{{ document }}</span>
      </li>
    </ul>

    <h2 class="tc-check__title">Recuerda que no aceptamos</h2>

    <ul class="tc-check__exclusions">
      <li class="tc-check__item">
        <img :src="closeIcon1" alt="" aria-hidden="true">
        <span class="wd-body">Remodelaciones</span>
      </li>
      <li class="tc-check__item">
        <img :src="closeIcon2" alt="" aria-hidden="true">
        <span class="tc-check__labels">
          <span class="wd-body">Terrenos irregulares</span>
          <span class="tc-check__detail">(que no cumplan con las políticas de urbanización.)</span>
        </span>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import checkIcon from '../../../assets/tu-construye-figma/check.svg'
import closeIcon1 from '../../../assets/tu-construye-figma/close-1.svg'
import closeIcon2 from '../../../assets/tu-construye-figma/close-2.svg'

const documents = [
  'Escrituras',
  'Boleta predial',
  'Recibo de agua',
  'Identificación oficial',
  'Comprobantes',
  'Avalúo del terreno',
  'Licencia de Construcción',
  'Presupuesto de obra'
]
</script>

<style scoped>
.tc-check {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-5);
  padding: var(--ds-space-5) var(--ds-space-6);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 16px;
}

.tc-check__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 40px;
  font-weight: 700;
  line-height: 44px;
}

.tc-check__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--ds-space-5);
  margin: 0;
  padding: 0;
  list-style: none;
}

.tc-check__exclusions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--ds-space-5);
  margin: 0;
  padding: 0;
  list-style: none;
}

.tc-check__item { display: flex; align-items: center; gap: var(--ds-space-4); }
.tc-check__item img { flex: 0 0 24px; width: 24px; height: 24px; object-fit: contain; }
.tc-check__labels { display: flex; flex: 1 1 0; flex-direction: column; min-width: 0; }
.tc-check__detail { color: var(--ds-text-body); font-size: 14px; line-height: 20px; }

@media (max-width: 1024px) {
  .tc-check__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 599px) {
  .tc-check { padding: var(--ds-space-5) var(--ds-space-4); }
  .tc-check__grid,
  .tc-check__exclusions { grid-template-columns: minmax(0, 1fr); }
}
</style>
